module.exports = __webpack_public_path__ + "static/media/wepik-export-20230616024946Wg83.e5a7d93c.png";